import React from 'react'

class Default extends React.Component {
    public render() {
        return (
            <ul className="nav navbar-nav">
                <li className="logo-nav">
                    <a href="/dashboard">
                        <img src="/assets/img/tideways-small.png" alt="Dashboard" width="18" height="18" />
                    </a>
                </li>
            </ul>
        )
    }
}

export default Default
